import type { OrganizationLicenses } from '../../../../utils/types/admin_types';

export type BillingLicenseKey = keyof Omit<OrganizationLicenses, 'organizationId'>;

export interface IBillingLicenseCatalogItem {
  id: string;
  licenseKey: BillingLicenseKey;
  label: string;
  iconPath: string;
  iconClassName: string;
  isSpecialIcon?: boolean;
  creditUnit?: string;
}

export const BILLING_LICENSE_KEY_MAP: Record<string, BillingLicenseKey> = {
  hierTalentBase: 'hierTalentBase',
  autoAssessments: 'hierTalentAutoAssessments',
  autoClassify: 'hierTalentAutoClassify',
  jobPost: 'hierTalentJobPost',
  smartInterviews: 'hierTalentSmartInterviews',
  candiBank: 'hierTalentCandiBank',
  cca: 'hierTalentCca',
  psychometricFaxtor: 'hierTalentPsychometricFaxtor',
  wellness: 'hierTalentWellness',
  reporting: 'hierTalentReporting',
};

export const BILLING_LICENSE_CATALOG: IBillingLicenseCatalogItem[] = [
  {
    id: 'hierTalentBase',
    licenseKey: 'hierTalentBase',
    label: 'HierTalent Base',
    iconPath: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    iconClassName: 'bg-emerald-50 text-emerald-600',
  },
  {
    id: 'autoAssessments',
    licenseKey: 'hierTalentAutoAssessments',
    label: 'Auto Assessments',
    iconPath: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    iconClassName: 'bg-blue-50 text-blue-600',
  },
  {
    id: 'autoClassify',
    licenseKey: 'hierTalentAutoClassify',
    label: 'Auto Classify',
    iconPath: 'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
    iconClassName: 'bg-indigo-50 text-indigo-600',
  },
  {
    id: 'jobPost',
    licenseKey: 'hierTalentJobPost',
    label: 'Job Post',
    iconPath: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    iconClassName: 'bg-amber-50 text-amber-600',
  },
  {
    id: 'smartInterviews',
    licenseKey: 'hierTalentSmartInterviews',
    label: 'Smart Interviews',
    iconPath: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
    iconClassName: 'bg-rose-50 text-rose-600',
  },
  {
    id: 'candiBank',
    licenseKey: 'hierTalentCandiBank',
    label: 'CandiBank',
    iconPath: 'M8 14v20M24 14v20M8 24h16',
    iconClassName: 'bg-slate-900 text-white',
    isSpecialIcon: true,
    creditUnit: 'CVs',
  },
  {
    id: 'cca',
    licenseKey: 'hierTalentCca',
    label: 'CCA',
    iconPath: 'M8 14v20M24 14v20M8 24h16',
    iconClassName: 'bg-slate-900 text-white',
    isSpecialIcon: true,
  },
  {
    id: 'psychometricFaxtor',
    licenseKey: 'hierTalentPsychometricFaxtor',
    label: 'Psychometric Faxtor',
    iconPath: 'M9 19V6l12-3v13M9 19a3 3 0 11-6 0 3 3 0 016 0zm12-3a3 3 0 11-6 0 3 3 0 016 0z',
    iconClassName: 'bg-purple-50 text-purple-600',
  },
  {
    id: 'reporting',
    licenseKey: 'hierTalentReporting',
    label: 'Reporting',
    iconPath: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    iconClassName: 'bg-cyan-50 text-cyan-600',
  },
  {
    id: 'wellness',
    licenseKey: 'hierTalentWellness',
    label: 'Wellness',
    iconPath: 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 10-7.78 7.78l1.06 1.06L12 21l7.78-7.55 1.06-1.06a5.5 5.5 0 000-7.78z',
    iconClassName: 'bg-teal-50 text-teal-600',
  },
];
